import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { EnvironmentCountries } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { useSettings } from '../../useSettings';
import { saveBlobDownload } from './saveBlobDownload';

interface HookProps {
  batchIds: string[];
}

export const useDownloadBulkUtbReport = () => {
  const { data: settings } = useSettings();
  const reportName = settings.country === EnvironmentCountries.NL ? 'UTB' : 'Customs Debt';

  return useMutation({
    mutationFn: async ({ batchIds }: HookProps) => {
      const result = await apiClient.batchesReports.downloadBulkUtbReport.mutation({ body: { batchIds } });
      if (result.status !== 200) throw result.body;

      saveBlobDownload(result.body as Blob, result.headers.get('content-disposition'));
    },
    onSuccess: () => {
      toast.success(`Successfully downloaded the ${reportName} reports!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading the ${reportName} reports!`);
    },
  });
};
